import { MenuPages } from '@/enums';

export const menu_external_links: Record<string, string> = {
  download_center_link: 'https://fs.atol.ru/',
  telephone: '+74957307420',
  e_mail: 'lkp@atol.ru',
  website: 'https://www.atol.ru',
};

export const external_link_names: string[] = [
  MenuPages.DOWNLOAD_CENTER,
  MenuPages.USER_GUIDE,
  MenuPages.TELEPHONE,
  MenuPages.E_MAIL,
  MenuPages.WEBSITE,
];
